import { migratePayloadStats } from "@/lib/statsContent";
import { sanitizePayload } from "@/lib/sanitizePayload";

export function defaultPayload() {
  return {
    ro: {},
    en: {},
    contactInfo: {},
    servicePages: { ro: {}, en: {} },
    branding: {},
  };
}

/** @param {unknown} raw */
export function normalizeBranding(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
  const o = /** @type {Record<string, unknown>} */ (raw);
  /** @type {Record<string, string | number | object>} */
  const out = {};
  if (typeof o.faviconUrl === "string") {
    const t = o.faviconUrl.trim();
    if (t) out.faviconUrl = t;
  }
  for (const key of ["logoWidthPx", "logoHeightPx", "footerLogoWidthPx", "footerLogoHeightPx"]) {
    if (o[key] == null || o[key] === "") continue;
    const n = Number(o[key]);
    if (Number.isFinite(n) && n > 0 && n <= 2000) out[key] = Math.round(n);
  }
  if (o.seo && typeof o.seo === "object" && !Array.isArray(o.seo)) {
    const seo = /** @type {Record<string, unknown>} */ (o.seo);
    const seoOut = {};
    for (const lang of ["ro", "en"]) {
      const block = seo[lang];
      if (!block || typeof block !== "object" || Array.isArray(block)) continue;
      const b = /** @type {Record<string, unknown>} */ (block);
      const entry = {};
      for (const k of ["siteTitle", "metaDescription", "shareTitle", "shareDescription", "shareImageUrl"]) {
        if (typeof b[k] === "string" && b[k].trim()) entry[k] = b[k].trim();
      }
      if (Object.keys(entry).length) seoOut[lang] = entry;
    }
    if (Object.keys(seoOut).length) out.seo = seoOut;
  }
  return out;
}

export function normalizePayload(parsed) {
  const base = defaultPayload();
  const normalized = {
    ro: typeof parsed.ro === "object" && parsed.ro !== null && !Array.isArray(parsed.ro) ? parsed.ro : base.ro,
    en: typeof parsed.en === "object" && parsed.en !== null && !Array.isArray(parsed.en) ? parsed.en : base.en,
    contactInfo:
      typeof parsed.contactInfo === "object" && parsed.contactInfo !== null && !Array.isArray(parsed.contactInfo)
        ? parsed.contactInfo
        : base.contactInfo,
    servicePages: {
      ro:
        parsed.servicePages?.ro && typeof parsed.servicePages.ro === "object" && !Array.isArray(parsed.servicePages.ro)
          ? parsed.servicePages.ro
          : base.servicePages.ro,
      en:
        parsed.servicePages?.en && typeof parsed.servicePages.en === "object" && !Array.isArray(parsed.servicePages.en)
          ? parsed.servicePages.en
          : base.servicePages.en,
    },
    branding: normalizeBranding(parsed.branding),
  };

  return migratePayloadStats(sanitizePayload(normalized));
}

export async function fetchSitePayload() {
  const r = await fetch("/api/site-content.php", { cache: "no-store", credentials: "include" });
  const j = await r.json();
  return normalizePayload({
    ro: j.ro || {},
    en: j.en || {},
    contactInfo: j.contactInfo || {},
    servicePages: {
      ro: j.servicePages?.ro || {},
      en: j.servicePages?.en || {},
    },
    branding: j.branding || {},
  });
}
